// client/src/components/SocialShare.jsx
import React from 'react';
import '../styles/SocialShare.css';

const SocialShare = ({ title, url }) => {
  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  const shareLinks = {
    vk: `https://vk.com/share.php?url=${encodedUrl}&title=${encodedTitle}`,
    ok: `https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.shareUrl=${encodedUrl}`,
    telegram: `https://t.me/share/url?url=${encodedUrl}&text=${encodedTitle}`,
    twitter: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`
  };

  return (
    <div className="social-share">
      <span className="share-label">Поделиться:</span>
      <a href={shareLinks.vk} target="_blank" rel="noopener noreferrer" className="share-icon vk">ВК</a>
      <a href={shareLinks.ok} target="_blank" rel="noopener noreferrer" className="share-icon ok">ОК</a>
    </div>
  );
};

export default SocialShare;